import { submitsTabUIInitialState } from "./uiLandingPageSubmitsTabState";

export const makeSubmitsTabUIActions = (set, get) => ({
  setShowDelForm: (show) =>
    set((s) => ({ submitsTabUI: { ...s.submitsTabUI, showDelForm: !!show } })),
  resetSubmitsTabUI: () => set({ submitsTabUI: submitsTabUIInitialState }),
});
